export const version = 1;

const data = [
  {
    id: 1,
    topic: "Array",
    title: "Reverse the array",
    link:
      "https://www.geeksforgeeks.org/write-a-program-to-reverse-an-array-or-string/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 2,
    topic: "Array",
    title: "Find the maximum and minimum element in an array",
    link: "https://www.geeksforgeeks.org/maximum-and-minimum-in-an-array/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 3,
    topic: "Array",
    title: 'Find the "Kth" max and min element of an array',
    link: "https://practice.geeksforgeeks.org/problems/kth-smallest-element/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 4,
    topic: "Array",
    title:
      "Given an array which consists of only 0, 1 and 2. Sort the array without using any sorting algo",
    link:
      "https://practice.geeksforgeeks.org/problems/sort-an-array-of-0s-1s-and-2s/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 5,
    topic: "Array",
    title: "Move all the negative elements to one side of the array",
    link:
      "https://www.geeksforgeeks.org/move-negative-numbers-beginning-positive-end-constant-extra-space/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 6,
    topic: "Array",
    title: "Find the Union and Intersection of the two sorted arrays.",
    link: "https://practice.geeksforgeeks.org/problems/union-of-two-arrays/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 7,
    topic: "Array",
    title: "Write a program to cyclically rotate an array by one.",
    link:
      "https://practice.geeksforgeeks.org/problems/cyclically-rotate-an-array-by-one/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 8,
    topic: "Array",
    title: "find Largest sum contiguous Subarray [V. IMP]",
    link: "https://practice.geeksforgeeks.org/problems/kadanes-algorithm/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 9,
    topic: "Array",
    title: "Minimise the maximum difference between heights [V.IMP]",
    link:
      "https://practice.geeksforgeeks.org/problems/minimize-the-heights3351/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 10,
    topic: "Array",
    title: "Minimum no. of Jumps to reach end of an array",
    link:
      "https://practice.geeksforgeeks.org/problems/minimum-number-of-jumps/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 11,
    topic: "Array",
    title: "find duplicate in an array of N+1 Integers",
    link: "https://leetcode.com/problems/find-the-duplicate-number/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 12,
    topic: "Array",
    title: "Merge 2 sorted arrays without using Extra space.",
    link:
      "https://practice.geeksforgeeks.org/problems/merge-two-sorted-arrays5135/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 13,
    topic: "Array",
    title: "Kadane's Algo [V.V.V.V.V IMP]",
    link: "https://practice.geeksforgeeks.org/problems/kadanes-algorithm/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 14,
    topic: "Array",
    title: "Merge Intervals",
    link: "https://leetcode.com/problems/merge-intervals/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 15,
    topic: "Array",
    title: "Next Permutation",
    link: "https://leetcode.com/problems/next-permutation/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 16,
    topic: "Array",
    title: "Count Inversion",
    link: "https://practice.geeksforgeeks.org/problems/inversion-of-array/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 17,
    topic: "Array",
    title: "Best time to buy and Sell stock",
    link: "https://leetcode.com/problems/best-time-to-buy-and-sell-stock/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 18,
    topic: "Array",
    title: "find all pairs on integer array whose sum is equal to given number",
    link:
      "https://practice.geeksforgeeks.org/problems/count-pairs-with-given-sum5022/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 19,
    topic: "Array",
    title: "find common elements In 3 sorted arrays",
    link: "https://practice.geeksforgeeks.org/problems/common-elements1132/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 20,
    topic: "Array",
    title:
      "Rearrange the array in alternating positive and negative items with O(1) extra space",
    link:
      "https://www.geeksforgeeks.org/rearrange-array-alternating-positive-negative-items-o1-extra-space/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 21,
    topic: "Array",
    title: "Find if there is any subarray with sum equal to 0",
    link: "https://practice.geeksforgeeks.org/problems/subarray-with-0-sum/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 22,
    topic: "Array",
    title: "Find factorial of a large number",
    link:
      "https://practice.geeksforgeeks.org/problems/factorials-of-large-numbers/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 23,
    topic: "Array",
    title: "find maximum product subarray",
    link:
      "https://practice.geeksforgeeks.org/problems/maximum-product-subarray3604/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 24,
    topic: "Array",
    title: "Find longest coinsecutive subsequence",
    link:
      "https://practice.geeksforgeeks.org/problems/longest-consecutive-subsequence/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 25,
    topic: "Array",
    title:
      'Given an array of size n and a number k, fin all elements that appear more than " n/k " times.',
    link:
      "https://www.geeksforgeeks.org/given-an-array-of-of-size-n-finds-all-the-elements-that-appear-more-than-nk-times/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 26,
    topic: "Array",
    title: "Maximum profit by buying and selling a share atmost twice",
    link:
      "https://www.geeksforgeeks.org/maximum-profit-by-buying-and-selling-a-share-at-most-twice/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 27,
    topic: "Array",
    title: "Find whether an array is a subset of another array",
    link:
      "https://practice.geeksforgeeks.org/problems/array-subset-of-another-array/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 28,
    topic: "Array",
    title: "Find the triplet that sum to a given value",
    link: "https://practice.geeksforgeeks.org/problems/triplet-sum-in-array/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 29,
    topic: "Array",
    title: "Trapping Rain water problem",
    link: "https://practice.geeksforgeeks.org/problems/trapping-rain-water/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 30,
    topic: "Array",
    title: "Chocolate Distribution problem",
    link:
      "https://practice.geeksforgeeks.org/problems/chocolate-distribution-problem/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 31,
    topic: "Array",
    title: "Smallest Subarray with sum greater than a given value",
    link:
      "https://practice.geeksforgeeks.org/problems/smallest-subarray-with-sum-greater-than-x/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 32,
    topic: "Array",
    title: "Three way partitioning of an array around a given value",
    link:
      "https://practice.geeksforgeeks.org/problems/three-way-partitioning/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 33,
    topic: "Array",
    title: "Minimum swaps required bring elements less equal K together",
    link:
      "https://practice.geeksforgeeks.org/problems/minimum-swaps-required-to-bring-all-elements-less-than-or-equal-to-k-together/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 34,
    topic: "Array",
    title: "Minimum no. of operations required to make an array palindrome",
    link: "https://practice.geeksforgeeks.org/problems/palindromic-array/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 35,
    topic: "Array",
    title: "Median of 2 sorted arrays of equal size",
    link: "https://practice.geeksforgeeks.org/problems/find-the-median0527/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 36,
    topic: "Array",
    title: "Median of 2 sorted arrays of different size",
    link:
      "https://www.geeksforgeeks.org/median-of-two-sorted-arrays-of-different-sizes/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 39,
    topic: "Matrix",
    title: "Spiral traversal on a Matrix",
    link:
      "https://practice.geeksforgeeks.org/problems/spirally-traversing-a-matrix/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 40,
    topic: "Matrix",
    title: "Search an element in a matriix",
    link: "https://leetcode.com/problems/search-a-2d-matrix/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 41,
    topic: "Matrix",
    title: "Find median in a row wise sorted matrix",
    link:
      "https://practice.geeksforgeeks.org/problems/median-in-a-row-wise-sorted-matrix1527/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 42,
    topic: "Matrix",
    title: "Find row with maximum no. of 1's",
    link: "https://practice.geeksforgeeks.org/problems/row-with-max-1s0023/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 43,
    topic: "Matrix",
    title: "Print elements in sorted order using row-column wise sorted matrix",
    link: "https://practice.geeksforgeeks.org/problems/sorted-matrix/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 44,
    topic: "Matrix",
    title: "Maximum size rectangle",
    link: "https://practice.geeksforgeeks.org/problems/max-rectangle/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 45,
    topic: "Matrix",
    title: "Find a specific pair in matrix",
    link: "https://www.geeksforgeeks.org/find-a-specific-pair-in-matrix/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 46,
    topic: "Matrix",
    title: "Rotate matrix by 90 degrees",
    link:
      "https://www.geeksforgeeks.org/rotate-a-matrix-by-90-degree-in-clockwise-direction-without-using-any-extra-space/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 47,
    topic: "Matrix",
    title: "Kth smallest element in a row-cpumn wise sorted matrix",
    link: "https://practice.geeksforgeeks.org/problems/kth-element-in-matrix/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 48,
    topic: "Matrix",
    title: "Common elements in all rows of a given matrix",
    link:
      "https://www.geeksforgeeks.org/common-elements-in-all-rows-of-a-given-matrix/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 51,
    topic: "String",
    title: "Reverse a String",
    link: "https://leetcode.com/problems/reverse-string/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 52,
    topic: "String",
    title: "Check whether a String is Palindrome or not",
    link: "https://practice.geeksforgeeks.org/problems/palindrome-string0817/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 53,
    topic: "String",
    title: "Find Duplicate characters in a string",
    link:
      "https://www.geeksforgeeks.org/print-all-the-duplicates-in-the-input-string/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 55,
    topic: "String",
    title: "Write a Code to check whether one string is a rotation of another",
    link:
      "https://www.geeksforgeeks.org/a-program-to-check-if-strings-are-rotations-of-each-other/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 56,
    topic: "String",
    title:
      "Write a Program to check whether a string is a valid shuffle of two strings or not",
    link:
      "https://www.programiz.com/java-programming/examples/check-valid-shuffle-of-strings",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 57,
    topic: "String",
    title: "Count and Say problem",
    link: "https://leetcode.com/problems/count-and-say/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 58,
    topic: "String",
    title:
      "Write a program to find the longest Palindrome in a string.[ Longest palindromic Substring]",
    link:
      "https://practice.geeksforgeeks.org/problems/longest-palindrome-in-a-string/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 59,
    topic: "String",
    title: "Find Longest Recurring Subsequence in String",
    link:
      "https://practice.geeksforgeeks.org/problems/longest-repeating-subsequence/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 60,
    topic: "String",
    title: "Print all Subsequences of a string.",
    link: "https://www.geeksforgeeks.org/print-subsequences-string/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 61,
    topic: "String",
    title: "Print all the permutations of the given string",
    link:
      "https://practice.geeksforgeeks.org/problems/permutations-of-a-given-string/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 62,
    topic: "String",
    title: "Split the Binary string into two substring with equal 0’s and 1’s",
    link:
      "https://www.geeksforgeeks.org/split-the-binary-string-into-substrings-with-equal-number-of-0s-and-1s/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 63,
    topic: "String",
    title: "Word Wrap Problem [VERY IMP].",
    link: "https://practice.geeksforgeeks.org/problems/word-wrap/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 64,
    topic: "String",
    title: "EDIT Distance [Very Imp]",
    link: "https://practice.geeksforgeeks.org/problems/edit-distance3702/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 65,
    topic: "String",
    title: "Find next greater number with same set of digits. [Very Very IMP]",
    link: "https://practice.geeksforgeeks.org/problems/next-permutation/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 66,
    topic: "String",
    title: "Balanced Parenthesis problem.[Imp]",
    link: "https://practice.geeksforgeeks.org/problems/parenthesis-checker/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 67,
    topic: "String",
    title: "Word break Problem[ Very Imp]",
    link: "https://practice.geeksforgeeks.org/problems/word-break/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 68,
    topic: "String",
    title: "Rabin Karp Algo",
    link:
      "https://www.geeksforgeeks.org/rabin-karp-algorithm-for-pattern-searching/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 69,
    topic: "String",
    title: "KMP Algo",
    link:
      "https://practice.geeksforgeeks.org/problems/longest-prefix-suffix2527/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 70,
    topic: "String",
    title:
      "Convert a Sentence into its equivalent mobile numeric keypad sequence.",
    link:
      "https://www.geeksforgeeks.org/convert-sentence-equivalent-mobile-numeric-keypad-sequence/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 71,
    topic: "String",
    title:
      "Minimum number of bracket reversals needed to make an expression balanced.",
    link: "https://practice.geeksforgeeks.org/problems/count-the-reversals/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 72,
    topic: "String",
    title: "Count All Palindromic Subsequence in a given String.",
    link:
      "https://practice.geeksforgeeks.org/problems/count-palindromic-subsequences/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 73,
    topic: "String",
    title: "Count of number of given string in 2D character array",
    link:
      "https://www.geeksforgeeks.org/find-count-number-given-string-present-2d-character-array/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 74,
    topic: "String",
    title: "Search a Word in a 2D Grid of characters.",
    link:
      "https://practice.geeksforgeeks.org/problems/find-the-string-in-grid/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 75,
    topic: "String",
    title: "Boyer Moore Algorithm for Pattern Searching.",
    link:
      "https://www.geeksforgeeks.org/boyer-moore-algorithm-for-pattern-searching/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 76,
    topic: "String",
    title: "Converting Roman Numerals to Decimal",
    link:
      "https://practice.geeksforgeeks.org/problems/roman-number-to-integer/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 77,
    topic: "String",
    title: "Longest Common Prefix",
    link: "https://leetcode.com/problems/longest-common-prefix/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 78,
    topic: "String",
    title: "Number of flips to make binary string alternate",
    link: "https://practice.geeksforgeeks.org/problems/min-number-of-flips/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 79,
    topic: "String",
    title: "Find the first repeated word in string.",
    link:
      "https://practice.geeksforgeeks.org/problems/second-most-repeated-string-in-a-sequence/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 80,
    topic: "String",
    title: "Minimum number of swaps for bracket balancing.",
    link:
      "https://practice.geeksforgeeks.org/problems/minimum-swaps-for-bracket-balancing/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 81,
    topic: "String",
    title: "Find the longest common subsequence between two strings.",
    link:
      "https://practice.geeksforgeeks.org/problems/longest-common-subsequence/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 82,
    topic: "String",
    title:
      "Program to generate all possible valid IP addresses from given string.",
    link:
      "https://www.geeksforgeeks.org/program-generate-possible-valid-ip-addresses-given-string/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 83,
    topic: "String",
    title:
      "Write a program tofind the smallest window that contains all characters of string itself.",
    link:
      "https://practice.geeksforgeeks.org/problems/smallest-distant-window/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 84,
    topic: "String",
    title:
      "Rearrange characters in a string such that no two adjacent are same",
    link: "https://practice.geeksforgeeks.org/problems/rearrange-characters/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 85,
    topic: "String",
    title: "Minimum characters to be added at front to make string palindrome",
    link:
      "https://www.geeksforgeeks.org/minimum-characters-added-front-make-string-palindrome/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 86,
    topic: "String",
    title: "Given a sequence of words, print all anagrams together",
    link: "https://practice.geeksforgeeks.org/problems/k-anagrams-1/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 87,
    topic: "String",
    title:
      "Find the smallest window in a string containing all characters of another string",
    link:
      "https://practice.geeksforgeeks.org/problems/smallest-window-in-a-string-containing-all-the-characters-of-another-string/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 88,
    topic: "String",
    title: "Recursively remove all adjacent duplicates",
    link: "https://practice.geeksforgeeks.org/problems/consecutive-elements/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 89,
    topic: "String",
    title: "String matching where one string contains wildcard characters",
    link:
      "https://practice.geeksforgeeks.org/problems/wildcard-string-matching/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 90,
    topic: "String",
    title: "Function to find Number of customers who could not get a computer",
    link:
      "https://www.geeksforgeeks.org/function-to-find-number-of-customers-who-could-not-get-a-computer/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 91,
    topic: "String",
    title:
      "Transform One String to Another using Minimum Number of Given Operation",
    link:
      "https://www.geeksforgeeks.org/transform-one-string-to-another-using-minimum-number-of-given-operation/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 92,
    topic: "String",
    title: "Check if two given strings are isomorphic to each other",
    link: "https://practice.geeksforgeeks.org/problems/isomorphic-strings/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 93,
    topic: "String",
    title:
      "Recursively print all sentences that can be formed from list of word lists",
    link:
      "https://www.geeksforgeeks.org/recursively-print-all-sentences-that-can-be-formed-from-list-of-word-lists/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 96,
    topic: "Searching & Sorting",
    title: "Find first and last positions of an element in a sorted array",
    link:
      "https://practice.geeksforgeeks.org/problems/first-and-last-occurrences-of-x/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 97,
    topic: "Searching & Sorting",
    title: "Find a Fixed Point (Value equal to index) in a given array",
    link:
      "https://practice.geeksforgeeks.org/problems/value-equal-to-index-value1330/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 98,
    topic: "Searching & Sorting",
    title: "Search in a rotated sorted array",
    link: "https://leetcode.com/problems/search-in-rotated-sorted-array/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 99,
    topic: "Searching & Sorting",
    title: "square root of an integer",
    link: "https://practice.geeksforgeeks.org/problems/count-squares3649/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 100,
    topic: "Searching & Sorting",
    title:
      "Maximum and minimum of an array using minimum number of comparisons",
    link: "https://practice.geeksforgeeks.org/problems/middle-of-three2926/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 101,
    topic: "Searching & Sorting",
    title: "Optimum location of point to minimize total distance",
    link:
      "https://www.geeksforgeeks.org/optimum-location-point-minimize-total-distance/#:~:text=We%20need%20to%20find%20a,set%20of%20points%20is%20minimum.&text=In%20above%20figure%20optimum%20location,is%20minimum%20obtainable%20total%20distance.",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 102,
    topic: "Searching & Sorting",
    title: "Find the repeating and the missing",
    link:
      "https://practice.geeksforgeeks.org/problems/find-missing-and-repeating2512/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 103,
    topic: "Searching & Sorting",
    title: "find majority element",
    link: "https://practice.geeksforgeeks.org/problems/majority-element/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 104,
    topic: "Searching & Sorting",
    title: "Searching in an array where adjacent differ by at most k",
    link: "https://www.geeksforgeeks.org/searching-array-adjacent-differ-k/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 105,
    topic: "Searching & Sorting",
    title: "find a pair with a given difference",
    link:
      "https://practice.geeksforgeeks.org/problems/find-pair-given-difference/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 106,
    topic: "Searching & Sorting",
    title: "find four elements that sum to a given value",
    link:
      "https://practice.geeksforgeeks.org/problems/find-all-four-sum-numbers/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 107,
    topic: "Searching & Sorting",
    title: "maximum sum such that no 2 elements are adjacent",
    link: "https://practice.geeksforgeeks.org/problems/stickler-theif/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 108,
    topic: "Searching & Sorting",
    title: "Count triplet with sum smaller than a given value",
    link:
      "https://practice.geeksforgeeks.org/problems/count-triplets-with-sum-smaller-than-x5549/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 109,
    topic: "Searching & Sorting",
    title: "merge 2 sorted arrays",
    link:
      "https://practice.geeksforgeeks.org/problems/merge-two-sorted-arrays5135/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 110,
    topic: "Searching & Sorting",
    title: "print all subarrays with 0 sum",
    link: "https://practice.geeksforgeeks.org/problems/zero-sum-subarrays/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 111,
    topic: "Searching & Sorting",
    title: "Product array Puzzle",
    link: "https://practice.geeksforgeeks.org/problems/product-array-puzzle/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 112,
    topic: "Searching & Sorting",
    title: "Sort array according to count of set bits",
    link: "https://practice.geeksforgeeks.org/problems/sort-by-set-bit-count/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 113,
    topic: "Searching & Sorting",
    title: "minimum no. of swaps required to sort the array",
    link: "https://practice.geeksforgeeks.org/problems/minimum-swaps/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 114,
    topic: "Searching & Sorting",
    title: "Bishu and Soldiers",
    link:
      "https://www.hackerearth.com/practice/algorithms/searching/binary-search/practice-problems/algorithm/bishu-and-soldiers/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 115,
    topic: "Searching & Sorting",
    title: "Rasta and Kheshtak",
    link:
      "https://www.hackerearth.com/practice/algorithms/searching/binary-search/practice-problems/algorithm/rasta-and-kheshtak/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 116,
    topic: "Searching & Sorting",
    title: "Kth smallest number again",
    link:
      "https://www.hackerearth.com/practice/algorithms/searching/binary-search/practice-problems/algorithm/kth-smallest-number-again-2/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 117,
    topic: "Searching & Sorting",
    title: "Find pivot element in a sorted array",
    link:
      "http://theoryofprogramming.com/2017/12/16/find-pivot-element-sorted-rotated-array/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 118,
    topic: "Searching & Sorting",
    title: "K-th Element of Two Sorted Arrays",
    link:
      "https://practice.geeksforgeeks.org/problems/k-th-element-of-two-sorted-array/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 119,
    topic: "Searching & Sorting",
    title: "Aggressive cows",
    link: "https://www.spoj.com/problems/AGGRCOW/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 120,
    topic: "Searching & Sorting",
    title: "Book Allocation Problem",
    link:
      "https://practice.geeksforgeeks.org/problems/allocate-minimum-number-of-pages/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 121,
    topic: "Searching & Sorting",
    title: "EKOSPOJ:",
    link: "https://www.spoj.com/problems/EKO/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 122,
    topic: "Searching & Sorting",
    title: "Job Scheduling Algo",
    link: "https://www.geeksforgeeks.org/weighted-job-scheduling-log-n-time/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 123,
    topic: "Searching & Sorting",
    title: "Missing Number in AP",
    link: "https://practice.geeksforgeeks.org/problems/arithmetic-number/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 124,
    topic: "Searching & Sorting",
    title: "Smallest number with atleastn trailing zeroes infactorial",
    link:
      "https://practice.geeksforgeeks.org/problems/smallest-factorial-number5929/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 125,
    topic: "Searching & Sorting",
    title: "Painters Partition Problem:",
    link:
      "https://practice.geeksforgeeks.org/problems/allocate-minimum-number-of-pages/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 126,
    topic: "Searching & Sorting",
    title: "ROTI-Prata SPOJ",
    link: "https://www.spoj.com/problems/PRATA/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 127,
    topic: "Searching & Sorting",
    title: "DoubleHelix SPOJ",
    link: "https://www.spoj.com/problems/ANARC05B/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 128,
    topic: "Searching & Sorting",
    title: "Subset Sums",
    link: "https://www.spoj.com/problems/SUBSUMS/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 129,
    topic: "Searching & Sorting",
    title: "Findthe inversion count",
    link: "https://practice.geeksforgeeks.org/problems/inversion-of-array/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 130,
    topic: "Searching & Sorting",
    title: "Implement Merge-sort in-place",
    link: "https://www.geeksforgeeks.org/in-place-merge-sort/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 131,
    topic: "Searching & Sorting",
    title: "Partitioning and Sorting Arrays with Many Repeated Entries",
    link: "https://www.baeldung.com/java-sorting-arrays-with-repeated-entries",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 134,
    topic: "LinkedList",
    title:
      "Write a Program to reverse the Linked List. (Both Iterative and recursive)",
    link: "https://www.geeksforgeeks.org/reverse-a-linked-list/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 135,
    topic: "LinkedList",
    title: "Reverse a Linked List in group of Given Size. [Very Imp]",
    link:
      "https://practice.geeksforgeeks.org/problems/reverse-a-linked-list-in-groups-of-given-size/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 136,
    topic: "LinkedList",
    title: "Write a program to Detect loop in a linked list.",
    link:
      "https://practice.geeksforgeeks.org/problems/detect-loop-in-linked-list/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 137,
    topic: "LinkedList",
    title: "Write a program to Delete loop in a linked list.",
    link:
      "https://practice.geeksforgeeks.org/problems/remove-loop-in-linked-list/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 138,
    topic: "LinkedList",
    title: "Find the starting point of the loop. ",
    link:
      "https://www.geeksforgeeks.org/find-first-node-of-loop-in-a-linked-list/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 139,
    topic: "LinkedList",
    title: "Remove Duplicates in a sorted Linked List.",
    link:
      "https://practice.geeksforgeeks.org/problems/remove-duplicate-element-from-sorted-linked-list/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 140,
    topic: "LinkedList",
    title: "Remove Duplicates in a Un-sorted Linked List.",
    link:
      "https://practice.geeksforgeeks.org/problems/remove-duplicates-from-an-unsorted-linked-list/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 141,
    topic: "LinkedList",
    title:
      "Write a Program to Move the last element to Front in a Linked List.",
    link:
      "https://www.geeksforgeeks.org/move-last-element-to-front-of-a-given-linked-list/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 142,
    topic: "LinkedList",
    title: "Add “1” to a number represented as a Linked List.",
    link:
      "https://practice.geeksforgeeks.org/problems/add-1-to-a-number-represented-as-linked-list/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 143,
    topic: "LinkedList",
    title: "Add two numbers represented by linked lists.",
    link:
      "https://practice.geeksforgeeks.org/problems/add-two-numbers-represented-by-linked-lists/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 144,
    topic: "LinkedList",
    title: "Intersection of two Sorted Linked List.",
    link:
      "https://practice.geeksforgeeks.org/problems/intersection-of-two-sorted-linked-lists/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 145,
    topic: "LinkedList",
    title: "Intersection Point of two Linked Lists.",
    link:
      "https://practice.geeksforgeeks.org/problems/intersection-point-in-y-shapped-linked-lists/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 146,
    topic: "LinkedList",
    title: "Merge Sort For Linked lists.[Very Important]",
    link: "https://practice.geeksforgeeks.org/problems/sort-a-linked-list/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 147,
    topic: "LinkedList",
    title: "Quicksort for Linked Lists.[Very Important]",
    link:
      "https://practice.geeksforgeeks.org/problems/quick-sort-on-linked-list/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 148,
    topic: "LinkedList",
    title: "Find the middle Element of a linked list.",
    link: "https://leetcode.com/problems/middle-of-the-linked-list/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 149,
    topic: "LinkedList",
    title: "Check if a linked list is a circular linked list.",
    link: "https://practice.geeksforgeeks.org/problems/circular-linked-list/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 150,
    topic: "LinkedList",
    title: "Split a Circular linked list into two halves.",
    link:
      "https://practice.geeksforgeeks.org/problems/split-a-circular-linked-list-into-two-halves/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 151,
    topic: "LinkedList",
    title:
      "Write a Program to check whether the Singly Linked list is a palindrome or not.",
    link:
      "https://practice.geeksforgeeks.org/problems/check-if-linked-list-is-pallindrome/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 152,
    topic: "LinkedList",
    title: "Deletion from a Circular Linked List.",
    link: "https://www.geeksforgeeks.org/deletion-circular-linked-list/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 153,
    topic: "LinkedList",
    title: "Reverse a Doubly Linked list.",
    link:
      "https://practice.geeksforgeeks.org/problems/reverse-a-doubly-linked-list/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 154,
    topic: "LinkedList",
    title: "Find pairs with a given sum in a DLL.",
    link:
      "https://www.geeksforgeeks.org/find-pairs-given-sum-doubly-linked-list/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 155,
    topic: "LinkedList",
    title:
      "Count triplets in a sorted DLL whose sum is equal to given value “X”.",
    link:
      "https://www.geeksforgeeks.org/count-triplets-sorted-doubly-linked-list-whose-sum-equal-given-value-x/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 156,
    topic: "LinkedList",
    title: "Sort a “k”sorted Doubly Linked list.[Very IMP]",
    link: "https://www.geeksforgeeks.org/sort-k-sorted-doubly-linked-list/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 157,
    topic: "LinkedList",
    title: "Rotate DoublyLinked list by N nodes.",
    link: "https://www.geeksforgeeks.org/rotate-doubly-linked-list-n-nodes/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 158,
    topic: "LinkedList",
    title: "Rotate a Doubly Linked list in group of Given Size.[Very IMP]",
    link:
      "https://www.geeksforgeeks.org/reverse-doubly-linked-list-groups-given-size/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 161,
    topic: "LinkedList",
    title: "Flatten a Linked List",
    link:
      "https://practice.geeksforgeeks.org/problems/flattening-a-linked-list/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 162,
    topic: "LinkedList",
    title: "Sort a LL of 0's, 1's and 2's",
    link:
      "https://practice.geeksforgeeks.org/problems/given-a-linked-list-of-0s-1s-and-2s-sort-it/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 163,
    topic: "LinkedList",
    title: "Clone a linked list with next and random pointer",
    link:
      "https://practice.geeksforgeeks.org/problems/clone-a-linked-list-with-next-and-random-pointer/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 164,
    topic: "LinkedList",
    title: "Merge K sorted Linked list",
    link:
      "https://practice.geeksforgeeks.org/problems/merge-k-sorted-linked-lists/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 165,
    topic: "LinkedList",
    title: "Multiply 2 no. represented by LL",
    link:
      "https://practice.geeksforgeeks.org/problems/multiply-two-linked-lists/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 166,
    topic: "LinkedList",
    title: "Delete nodes which have a greater value on right side",
    link:
      "https://practice.geeksforgeeks.org/problems/delete-nodes-having-greater-value-on-right/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 167,
    topic: "LinkedList",
    title: "Segregate even and odd nodes in a Linked List",
    link:
      "https://practice.geeksforgeeks.org/problems/segregate-even-and-odd-nodes-in-a-linked-list/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 168,
    topic: "LinkedList",
    title: "Program for n’th node from the end of a Linked List",
    link:
      "https://practice.geeksforgeeks.org/problems/nth-node-from-end-of-linked-list/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 169,
    topic: "LinkedList",
    title: "Find the first non-repeating character from a stream of characters",
    link:
      "https://practice.geeksforgeeks.org/problems/first-non-repeating-character-in-a-stream/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 172,
    topic: "Binary Trees",
    title: "level order traversal",
    link: "https://practice.geeksforgeeks.org/problems/level-order-traversal/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 173,
    topic: "Binary Trees",
    title: "Reverse Level Order traversal",
    link:
      "https://practice.geeksforgeeks.org/problems/reverse-level-order-traversal/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 174,
    topic: "Binary Trees",
    title: "Height of a tree",
    link: "https://practice.geeksforgeeks.org/problems/height-of-binary-tree/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 175,
    topic: "Binary Trees",
    title: "Diameter of a tree",
    link:
      "https://practice.geeksforgeeks.org/problems/diameter-of-binary-tree/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 176,
    topic: "Binary Trees",
    title: "Mirror of a tree",
    link:
      "https://www.geeksforgeeks.org/create-a-mirror-tree-from-the-given-binary-tree/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 177,
    topic: "Binary Trees",
    title: "Inorder Traversal of a tree both using recursion and Iteration",
    link:
      "https://www.techiedelight.com/inorder-tree-traversal-iterative-recursive/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 178,
    topic: "Binary Trees",
    title: "Preorder Traversal of a tree both using recursion and Iteration",
    link:
      "https://www.techiedelight.com/preorder-tree-traversal-iterative-recursive/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 179,
    topic: "Binary Trees",
    title: "Postorder Traversal of a tree both using recursion and Iteration",
    link:
      "https://www.techiedelight.com/postorder-tree-traversal-iterative-recursive/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 180,
    topic: "Binary Trees",
    title: "Left View of a tree",
    link:
      "https://practice.geeksforgeeks.org/problems/left-view-of-binary-tree/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 181,
    topic: "Binary Trees",
    title: "Right View of Tree",
    link:
      "https://practice.geeksforgeeks.org/problems/right-view-of-binary-tree/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 182,
    topic: "Binary Trees",
    title: "Top View of a tree",
    link:
      "https://practice.geeksforgeeks.org/problems/top-view-of-binary-tree/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 183,
    topic: "Binary Trees",
    title: "Bottom View of a tree",
    link:
      "https://practice.geeksforgeeks.org/problems/bottom-view-of-binary-tree/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 184,
    topic: "Binary Trees",
    title: "Zig-Zag traversal of a binary tree",
    link: "https://practice.geeksforgeeks.org/problems/zigzag-tree-traversal/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 185,
    topic: "Binary Trees",
    title: "Check if a tree is balanced or not",
    link:
      "https://practice.geeksforgeeks.org/problems/check-for-balanced-tree/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 186,
    topic: "Binary Trees",
    title: "Diagnol Traversal of a Binary tree",
    link: "https://www.geeksforgeeks.org/diagonal-traversal-of-binary-tree/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 187,
    topic: "Binary Trees",
    title: "Boundary traversal of a Binary tree",
    link:
      "https://practice.geeksforgeeks.org/problems/boundary-traversal-of-binary-tree/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 188,
    topic: "Binary Trees",
    title: "Construct Binary Tree from String with Bracket Representation",
    link:
      "https://www.geeksforgeeks.org/construct-binary-tree-string-bracket-representation/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 189,
    topic: "Binary Trees",
    title: "Convert Binary tree into Doubly Linked List",
    link: "https://practice.geeksforgeeks.org/problems/binary-tree-to-dll/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 190,
    topic: "Binary Trees",
    title: "Convert Binary tree into Sum tree",
    link: "https://practice.geeksforgeeks.org/problems/transform-to-sum-tree/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 191,
    topic: "Binary Trees",
    title: "Construct Binary tree from Inorder and preorder traversal",
    link: "https://practice.geeksforgeeks.org/problems/construct-tree-1/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 192,
    topic: "Binary Trees",
    title: "Find minimum swaps required to convert a Binary tree into BST",
    link:
      "https://www.geeksforgeeks.org/minimum-swap-required-convert-binary-tree-binary-search-tree/#:~:text=Given%20the%20array%20representation%20of,it%20into%20Binary%20Search%20Tree.&text=Swap%201%3A%20Swap%20node%208,node%209%20with%20node%2010.",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 193,
    topic: "Binary Trees",
    title: "Check if Binary tree is Sum tree or not",
    link: "https://practice.geeksforgeeks.org/problems/sum-tree/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 194,
    topic: "Binary Trees",
    title: "Check if all leaf nodes are at same level or not",
    link: "https://practice.geeksforgeeks.org/problems/leaf-at-same-level/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 195,
    topic: "Binary Trees",
    title:
      "Check if a Binary Tree contains duplicate subtrees of size 2 or more [ IMP ]",
    link:
      "https://practice.geeksforgeeks.org/problems/duplicate-subtree-in-binary-tree/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 196,
    topic: "Binary Trees",
    title: "Check if 2 trees are mirror or not",
    link:
      "https://practice.geeksforgeeks.org/problems/check-mirror-in-n-ary-tree/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 197,
    topic: "Binary Trees",
    title: "Sum of Nodes on the Longest path from root to leaf node",
    link:
      "https://practice.geeksforgeeks.org/problems/sum-of-the-longest-bloodline-of-a-tree/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 198,
    topic: "Binary Trees",
    title: "Check if given graph is tree or not. [ IMP ]",
    link:
      "https://www.geeksforgeeks.org/check-given-graph-tree/#:~:text=Since%20the%20graph%20is%20undirected,graph%20is%20connected%2C%20otherwise%20not.",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 199,
    topic: "Binary Trees",
    title: "Find Largest subtree sum in a tree",
    link: "https://www.geeksforgeeks.org/find-largest-subtree-sum-tree/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 200,
    topic: "Binary Trees",
    title: "Maximum Sum of nodes in Binary tree such that no two are adjacent",
    link:
      "https://www.geeksforgeeks.org/maximum-sum-nodes-binary-tree-no-two-adjacent/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 201,
    topic: "Binary Trees",
    title: 'Print all "K" Sum paths in a Binary tree',
    link: "https://www.geeksforgeeks.org/print-k-sum-paths-binary-tree/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 202,
    topic: "Binary Trees",
    title: "Find LCA in a Binary tree",
    link:
      "https://practice.geeksforgeeks.org/problems/lowest-common-ancestor-in-a-binary-tree/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 203,
    topic: "Binary Trees",
    title: "Find distance between 2 nodes in a Binary tree",
    link:
      "https://practice.geeksforgeeks.org/problems/min-distance-between-two-given-nodes-of-a-binary-tree/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 204,
    topic: "Binary Trees",
    title: "Kth Ancestor of node in a Binary tree",
    link: "https://www.geeksforgeeks.org/kth-ancestor-node-binary-tree-set-2/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 205,
    topic: "Binary Trees",
    title: "Find all Duplicate subtrees in a Binary tree [ IMP ]",
    link: "https://practice.geeksforgeeks.org/problems/duplicate-subtrees/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 206,
    topic: "Binary Trees",
    title: "Tree Isomorphism Problem",
    link:
      "https://practice.geeksforgeeks.org/problems/check-if-tree-is-isomorphic/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 209,
    topic: "Binary Search Trees",
    title: "Fina a value in a BST",
    link:
      "https://www.geeksforgeeks.org/binary-search-tree-set-1-search-and-insertion/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 210,
    topic: "Binary Search Trees",
    title: "Deletion of a node in a BST",
    link: "https://leetcode.com/problems/delete-node-in-a-bst/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 211,
    topic: "Binary Search Trees",
    title: "Find min and max value in a BST",
    link:
      "https://practice.geeksforgeeks.org/problems/minimum-element-in-bst/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 212,
    topic: "Binary Search Trees",
    title: "Find inorder successor and inorder predecessor in a BST",
    link:
      "https://practice.geeksforgeeks.org/problems/predecessor-and-successor/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 213,
    topic: "Binary Search Trees",
    title: "Check if a tree is a BST or not",
    link: "https://practice.geeksforgeeks.org/problems/check-for-bst/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 214,
    topic: "Binary Search Trees",
    title: "Populate Inorder successor of all nodes",
    link:
      "https://practice.geeksforgeeks.org/problems/populate-inorder-successor-for-all-nodes/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 215,
    topic: "Binary Search Trees",
    title: "Find LCA of 2 nodes in a BST",
    link:
      "https://practice.geeksforgeeks.org/problems/lowest-common-ancestor-in-a-bst/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 216,
    topic: "Binary Search Trees",
    title: "Construct BST from preorder traversal",
    link:
      "https://www.geeksforgeeks.org/construct-bst-from-given-preorder-traversa/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 217,
    topic: "Binary Search Trees",
    title: "Convert Binary tree into BST",
    link: "https://practice.geeksforgeeks.org/problems/binary-tree-to-bst/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 218,
    topic: "Binary Search Trees",
    title: "Convert a normal BST into a Balanced BST",
    link: "https://www.geeksforgeeks.org/convert-normal-bst-balanced-bst/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 219,
    topic: "Binary Search Trees",
    title: "Merge two BST [ V.V.V>IMP ]",
    link:
      "https://www.geeksforgeeks.org/merge-two-balanced-binary-search-trees/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 220,
    topic: "Binary Search Trees",
    title: "Find Kth largest element in a BST",
    link:
      "https://practice.geeksforgeeks.org/problems/kth-largest-element-in-bst/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 221,
    topic: "Binary Search Trees",
    title: "Find Kth smallest element in a BST",
    link:
      "https://practice.geeksforgeeks.org/problems/find-k-th-smallest-element-in-bst/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 222,
    topic: "Binary Search Trees",
    title: 'Count pairs from 2 BST whose sum is equal to given value "X"',
    link:
      "https://practice.geeksforgeeks.org/problems/brothers-from-different-root/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 223,
    topic: "Binary Search Trees",
    title: "Find the median of BST in O(n) time and O(1) space",
    link: "https://www.geeksforgeeks.org/find-median-bst-time-o1-space/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 224,
    topic: "Binary Search Trees",
    title: "Count BST ndoes that lie in a given range",
    link:
      "https://practice.geeksforgeeks.org/problems/count-bst-nodes-that-lie-in-a-given-range/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 225,
    topic: "Binary Search Trees",
    title: "Replace every element with the least greater element on its right",
    link:
      "https://www.geeksforgeeks.org/replace-every-element-with-the-least-greater-element-on-its-right/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 226,
    topic: "Binary Search Trees",
    title: 'Given "n" appointments, find the conflicting appointments',
    link:
      "https://www.geeksforgeeks.org/given-n-appointments-find-conflicting-appointments/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 227,
    topic: "Binary Search Trees",
    title: "Check preorder is valid or not",
    link: "https://practice.geeksforgeeks.org/problems/preorder-to-postorder/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 228,
    topic: "Binary Search Trees",
    title: "Check whether BST contains Dead end",
    link:
      "https://practice.geeksforgeeks.org/problems/check-whether-bst-contains-dead-end/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 229,
    topic: "Binary Search Trees",
    title: "Largest BST in a Binary Tree [ V.V.V.V.V IMP ]",
    link: "https://practice.geeksforgeeks.org/problems/largest-bst/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 230,
    topic: "Binary Search Trees",
    title: "Flatten BST to sorted list",
    link:
      "https://www.geeksforgeeks.org/flatten-bst-to-sorted-list-increasing-order/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 233,
    topic: "Greedy",
    title: "Activity Selection Problem",
    link:
      "https://practice.geeksforgeeks.org/problems/n-meetings-in-one-room/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 234,
    topic: "Greedy",
    title: "Job SequencingProblem",
    link:
      "https://practice.geeksforgeeks.org/problems/job-sequencing-problem/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 235,
    topic: "Greedy",
    title: "Huffman Coding",
    link: "https://practice.geeksforgeeks.org/problems/huffman-encoding/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 236,
    topic: "Greedy",
    title: "Water Connection Problem",
    link:
      "https://practice.geeksforgeeks.org/problems/water-connection-problem/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 237,
    topic: "Greedy",
    title: "Fractional Knapsack Problem",
    link: "https://practice.geeksforgeeks.org/problems/fractional-knapsack/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 238,
    topic: "Greedy",
    title: "Greedy Algorithm to find Minimum number of Coins",
    link: "https://practice.geeksforgeeks.org/problems/coin-piles/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 239,
    topic: "Greedy",
    title: "Maximum trains for which stoppage can be provided",
    link: "https://www.geeksforgeeks.org/maximum-trains-stoppage-can-provided/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 240,
    topic: "Greedy",
    title: "Minimum Platforms Problem",
    link: "https://practice.geeksforgeeks.org/problems/minimum-platforms/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 241,
    topic: "Greedy",
    title: "Buy Maximum Stocks if i stocks can be bought on i-th day",
    link:
      "https://www.geeksforgeeks.org/buy-maximum-stocks-stocks-can-bought-th-day/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 242,
    topic: "Greedy",
    title: "Find the minimum and maximum amount to buy all N candies",
    link: "https://practice.geeksforgeeks.org/problems/shop-in-candy-store/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 243,
    topic: "Greedy",
    title:
      "Minimize Cash Flow among a given set of friends who have borrowed money from each other",
    link:
      "https://www.geeksforgeeks.org/minimize-cash-flow-among-given-set-friends-borrowed-money/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 244,
    topic: "Greedy",
    title: "Minimum Cost to cut a board into squares",
    link: "https://www.geeksforgeeks.org/minimum-cost-cut-board-squares/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 245,
    topic: "Greedy",
    title: "Check if it is possible to survive on Island",
    link: "https://www.geeksforgeeks.org/survival/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 246,
    topic: "Greedy",
    title: "Find maximum meetings in one room",
    link: "https://www.geeksforgeeks.org/find-maximum-meetings-in-one-room/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 247,
    topic: "Greedy",
    title: "Maximum product subset of an array",
    link: "https://www.geeksforgeeks.org/maximum-product-subset-array/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 248,
    topic: "Greedy",
    title: "Maximize array sum after K negations",
    link:
      "https://practice.geeksforgeeks.org/problems/maximize-sum-after-k-negations/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 249,
    topic: "Greedy",
    title: "Maximize the sum of arr[i]*i",
    link:
      "https://practice.geeksforgeeks.org/problems/maximize-arrii-of-an-array/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 250,
    topic: "Greedy",
    title: "Maximum sum of absolute difference of an array",
    link:
      "https://www.geeksforgeeks.org/maximum-sum-absolute-difference-array/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 251,
    topic: "Greedy",
    title: "Maximize sum of consecutive differences in a circular array",
    link: "https://practice.geeksforgeeks.org/problems/swap-and-maximize/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 252,
    topic: "Greedy",
    title: "Minimum sum of absolute difference of pairs of two arrays",
    link:
      "https://www.geeksforgeeks.org/minimum-sum-absolute-difference-pairs-two-arrays/#:~:text=It%20consists%20of%20two%20steps,result%20to%20the%20sum%20S.",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 253,
    topic: "Greedy",
    title: "Program for Shortest Job First (or SJF) CPU Scheduling",
    link:
      "https://www.geeksforgeeks.org/program-for-shortest-job-first-or-sjf-cpu-scheduling-set-1-non-preemptive/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 254,
    topic: "Greedy",
    title: "Program for Least Recently Used (LRU) Page Replacement algorithm",
    link: "https://practice.geeksforgeeks.org/problems/page-faults-in-lru/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 255,
    topic: "Greedy",
    title: "Smallest subset with sum greater than all other elements",
    link: "https://www.geeksforgeeks.org/smallest-subset-sum-greater-elements/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 256,
    topic: "Greedy",
    title: "Chocolate Distribution Problem",
    link:
      "https://practice.geeksforgeeks.org/problems/chocolate-distribution-problem/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 257,
    topic: "Greedy",
    title: "DEFKIN -Defense of a Kingdom",
    link: "https://www.spoj.com/problems/DEFKIN/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 258,
    topic: "Greedy",
    title: "DIEHARD -DIE HARD",
    link: "https://www.spoj.com/problems/DIEHARD/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 259,
    topic: "Greedy",
    title: "GERGOVIA -Wine trading in Gergovia",
    link: "https://www.spoj.com/problems/GERGOVIA/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 260,
    topic: "Greedy",
    title: "Picking Up Chicks",
    link: "https://www.spoj.com/problems/GCJ101BB/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 261,
    topic: "Greedy",
    title: "CHOCOLA –Chocolate",
    link: "https://www.spoj.com/problems/CHOCOLA/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 262,
    topic: "Greedy",
    title: "ARRANGE -Arranging Amplifiers",
    link: "https://www.spoj.com/problems/ARRANGE/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 263,
    topic: "Greedy",
    title: "K Centers Problem",
    link:
      "https://www.geeksforgeeks.org/k-centers-problem-set-1-greedy-approximate-algorithm/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 264,
    topic: "Greedy",
    title: "Minimum Cost of ropes",
    link: "https://practice.geeksforgeeks.org/problems/minimum-cost-of-ropes/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 265,
    topic: "Greedy",
    title: "Find smallest number with given number of digits and sum of digits",
    link: "https://practice.geeksforgeeks.org/problems/smallest-number5829/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 266,
    topic: "Greedy",
    title:
      "Rearrange characters in a string such that no two adjacent are same",
    link: "https://practice.geeksforgeeks.org/problems/rearrange-characters/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 267,
    topic: "Greedy",
    title: "Find maximum sum possible equal sum of three stacks",
    link:
      "https://www.geeksforgeeks.org/find-maximum-sum-possible-equal-sum-three-stacks/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 270,
    topic: "BackTracking",
    title: "Rat in a maze Problem",
    link: "https://practice.geeksforgeeks.org/problems/rat-in-a-maze-problem/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 271,
    topic: "BackTracking",
    title: "Printing all solutions in N-Queen Problem",
    link: "https://www.geeksforgeeks.org/printing-solutions-n-queen-problem/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 272,
    topic: "BackTracking",
    title: "Word Break Problem using Backtracking",
    link: "https://practice.geeksforgeeks.org/problems/word-break-part-2/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 273,
    topic: "BackTracking",
    title: "Remove Invalid Parentheses",
    link: "https://leetcode.com/problems/remove-invalid-parentheses/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 274,
    topic: "BackTracking",
    title: "Sudoku Solver",
    link: "https://practice.geeksforgeeks.org/problems/solve-the-sudoku/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 275,
    topic: "BackTracking",
    title: "m Coloring Problem",
    link: "https://practice.geeksforgeeks.org/problems/m-coloring-problem/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 276,
    topic: "BackTracking",
    title: "Print all palindromic partitions of a string",
    link:
      "https://www.geeksforgeeks.org/given-a-string-print-all-possible-palindromic-partition/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 277,
    topic: "BackTracking",
    title: "Subset Sum Problem",
    link:
      "https://practice.geeksforgeeks.org/problems/subset-sum-problem2014/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 278,
    topic: "BackTracking",
    title: "The Knight’s tour problem",
    link:
      "https://www.geeksforgeeks.org/the-knights-tour-problem-backtracking-1/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 279,
    topic: "BackTracking",
    title: "Tug of War",
    link: "https://www.geeksforgeeks.org/tug-of-war/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 280,
    topic: "BackTracking",
    title: "Find shortest safe route in a path with landmines",
    link:
      "https://www.geeksforgeeks.org/find-shortest-safe-route-in-a-path-with-landmines/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 281,
    topic: "BackTracking",
    title: "Combinational Sum",
    link: "https://practice.geeksforgeeks.org/problems/combination-sum/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 282,
    topic: "BackTracking",
    title: "Find Maximum number possible by doing at-most K swaps",
    link:
      "https://practice.geeksforgeeks.org/problems/largest-number-in-k-swaps/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 283,
    topic: "BackTracking",
    title: "Print all permutations of a string",
    link:
      "https://practice.geeksforgeeks.org/problems/permutations-of-a-given-string/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 284,
    topic: "BackTracking",
    title: "Find if there is a path of more than k length from a source",
    link:
      "https://www.geeksforgeeks.org/find-if-there-is-a-path-of-more-than-k-length-from-a-source/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 285,
    topic: "BackTracking",
    title: "Longest Possible Route in a Matrix with Hurdles",
    link:
      "https://www.geeksforgeeks.org/longest-possible-route-in-a-matrix-with-hurdles/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 286,
    topic: "BackTracking",
    title:
      "Print all possible paths from top left to bottom right of a mXn matrix",
    link:
      "https://www.geeksforgeeks.org/print-all-possible-paths-from-top-left-to-bottom-right-of-a-mxn-matrix/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 287,
    topic: "BackTracking",
    title: "Partition of a set intoK subsets with equal sum",
    link:
      "https://practice.geeksforgeeks.org/problems/partition-array-to-k-subsets/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 288,
    topic: "BackTracking",
    title: "Find the K-th Permutation Sequence of first N natural numbers",
    link:
      "https://www.geeksforgeeks.org/find-the-k-th-permutation-sequence-of-first-n-natural-numbers/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 291,
    topic: "Stacks & Queues",
    title: "Implement Stack from Scratch",
    link: "https://www.tutorialspoint.com/javaexamples/data_stack.htm",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 292,
    topic: "Stacks & Queues",
    title: "Implement Queue from Scratch",
    link:
      "https://www.geeksforgeeks.org/queue-set-1introduction-and-array-implementation/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 293,
    topic: "Stacks & Queues",
    title: "Implement 2 stack in an array",
    link:
      "https://practice.geeksforgeeks.org/problems/implement-two-stacks-in-an-array/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 294,
    topic: "Stacks & Queues",
    title: "find the middle element of a stack",
    link:
      "https://www.geeksforgeeks.org/design-a-stack-with-find-middle-operation/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 295,
    topic: "Stacks & Queues",
    title: 'Implement "N" stacks in an Array',
    link:
      "https://www.geeksforgeeks.org/efficiently-implement-k-stacks-single-array/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 296,
    topic: "Stacks & Queues",
    title: "Check the expression has valid or Balanced parenthesis or not.",
    link: "https://practice.geeksforgeeks.org/problems/parenthesis-checker/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 297,
    topic: "Stacks & Queues",
    title: "Reverse a String using Stack",
    link:
      "https://practice.geeksforgeeks.org/problems/reverse-a-string-using-stack/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 298,
    topic: "Stacks & Queues",
    title:
      "Design a Stack that supports getMin() in O(1) time and O(1) extra space.",
    link: "https://practice.geeksforgeeks.org/problems/special-stack/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 299,
    topic: "Stacks & Queues",
    title: "Find the next Greater element",
    link: "https://practice.geeksforgeeks.org/problems/next-larger-element/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 300,
    topic: "Stacks & Queues",
    title: "The celebrity Problem",
    link: "https://practice.geeksforgeeks.org/problems/the-celebrity-problem/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 301,
    topic: "Stacks & Queues",
    title: "Arithmetic Expression evaluation",
    link:
      "https://www.geeksforgeeks.org/arithmetic-expression-evalution/#:~:text=The%20stack%20organization%20is%20very,i.e.%2C%20A%20%2B%20B).",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 302,
    topic: "Stacks & Queues",
    title: "Evaluation of Postfix expression",
    link:
      "https://practice.geeksforgeeks.org/problems/evaluation-of-postfix-expression/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 303,
    topic: "Stacks & Queues",
    title:
      "Implement a method to insert an element at its bottom without using any other data structure.",
    link:
      "https://stackoverflow.com/questions/45130465/inserting-at-the-end-of-stack",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 304,
    topic: "Stacks & Queues",
    title: "Reverse a stack using recursion",
    link: "https://www.geeksforgeeks.org/reverse-a-stack-using-recursion/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 305,
    topic: "Stacks & Queues",
    title: "Sort a Stack using recursion",
    link: "https://practice.geeksforgeeks.org/problems/sort-a-stack/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 306,
    topic: "Stacks & Queues",
    title: "Merge Overlapping Intervals",
    link: "https://practice.geeksforgeeks.org/problems/overlapping-intervals/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 307,
    topic: "Stacks & Queues",
    title: "Largest rectangular Area in Histogram",
    link:
      "https://practice.geeksforgeeks.org/problems/maximum-rectangular-area-in-a-histogram/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 308,
    topic: "Stacks & Queues",
    title: "Length of the Longest Valid Substring",
    link: "https://practice.geeksforgeeks.org/problems/valid-substring0624/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 309,
    topic: "Stacks & Queues",
    title: "Expression contains redundant bracket or not",
    link:
      "https://www.geeksforgeeks.org/expression-contains-redundant-bracket-not/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 310,
    topic: "Stacks & Queues",
    title: "Implement Stack using Queue",
    link:
      "https://practice.geeksforgeeks.org/problems/stack-using-two-queues/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 311,
    topic: "Stacks & Queues",
    title: "Implement Stack using Deque",
    link: "https://www.geeksforgeeks.org/implement-stack-queue-using-deque/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 312,
    topic: "Stacks & Queues",
    title:
      "Stack Permutations (Check if an array is stack permutation of other)",
    link:
      "https://www.geeksforgeeks.org/stack-permutations-check-if-an-array-is-stack-permutation-of-other/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 313,
    topic: "Stacks & Queues",
    title: "Implement Queue using Stack",
    link:
      "https://practice.geeksforgeeks.org/problems/queue-using-two-stacks/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 314,
    topic: "Stacks & Queues",
    title: 'Implement "n" queue in an array',
    link:
      "https://www.geeksforgeeks.org/efficiently-implement-k-queues-single-array/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 315,
    topic: "Stacks & Queues",
    title: "Implement a Circular queue",
    link:
      "https://www.geeksforgeeks.org/circular-queue-set-1-introduction-array-implementation/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 316,
    topic: "Stacks & Queues",
    title: "LRU Cache Implementationa",
    link: "https://practice.geeksforgeeks.org/problems/lru-cache/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 317,
    topic: "Stacks & Queues",
    title: "Reverse a Queue using recursion",
    link: "https://practice.geeksforgeeks.org/problems/queue-reversal/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 318,
    topic: "Stacks & Queues",
    title: "Reverse the first “K” elements of a queue",
    link:
      "https://practice.geeksforgeeks.org/problems/reverse-first-k-elements-of-queue/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 319,
    topic: "Stacks & Queues",
    title: "Interleave the first half of the queue with second half",
    link:
      "https://www.geeksforgeeks.org/interleave-first-half-queue-second-half/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 320,
    topic: "Stacks & Queues",
    title: "Find the first circular tour that visits all Petrol Pumps",
    link: "https://practice.geeksforgeeks.org/problems/circular-tour/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 321,
    topic: "Stacks & Queues",
    title: "Minimum time required to rot all oranges",
    link: "https://practice.geeksforgeeks.org/problems/rotten-oranges/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 322,
    topic: "Stacks & Queues",
    title: "Distance of nearest cell having 1 in a binary matrix",
    link:
      "https://practice.geeksforgeeks.org/problems/distance-of-nearest-cell-having-1/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 323,
    topic: "Stacks & Queues",
    title: "First negative integer in every window of size “k”",
    link:
      "https://practice.geeksforgeeks.org/problems/first-negative-integer-in-every-window-of-size-k/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 324,
    topic: "Stacks & Queues",
    title: "Check if all levels of two trees are anagrams or not.",
    link:
      "https://www.geeksforgeeks.org/check-if-all-levels-of-two-trees-are-anagrams-or-not/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 325,
    topic: "Stacks & Queues",
    title: "Sum of minimum and maximum elements of all subarrays of size “k”.",
    link:
      "https://www.geeksforgeeks.org/sum-minimum-maximum-elements-subarrays-size-k/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 326,
    topic: "Stacks & Queues",
    title:
      "Minimum sum of squares of character counts in a given string after removing “k” characters.",
    link: "https://practice.geeksforgeeks.org/problems/game-with-string/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 327,
    topic: "Stacks & Queues",
    title: "Queue based approach or first non-repeating character in a stream.",
    link:
      "https://practice.geeksforgeeks.org/problems/first-non-repeating-character-in-a-stream/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 328,
    topic: "Stacks & Queues",
    title: "Next Smaller Element",
    link: "https://www.geeksforgeeks.org/next-smaller-element/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 331,
    topic: "Heap",
    title: "Implement a Maxheap/MinHeap using arrays and recursion.",
    link: "https://www.geeksforgeeks.org/building-heap-from-array/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 332,
    topic: "Heap",
    title: "Sort an Array using heap. (HeapSort)",
    link: "https://www.geeksforgeeks.org/heap-sort/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 333,
    topic: "Heap",
    title: "Maximum of all subarrays of size k.",
    link:
      "https://www.geeksforgeeks.org/sliding-window-maximum-maximum-of-all-subarrays-of-size-k/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 334,
    topic: "Heap",
    title: "“k” largest element in an array",
    link:
      "https://practice.geeksforgeeks.org/problems/k-largest-elements4206/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 335,
    topic: "Heap",
    title: "Kth smallest and largest element in an unsorted array",
    link:
      "https://www.geeksforgeeks.org/kth-smallestlargest-element-unsorted-array/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 336,
    topic: "Heap",
    title: "Merge “K” sorted arrays. [ IMP ]",
    link: "https://practice.geeksforgeeks.org/problems/merge-k-sorted-arrays/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 337,
    topic: "Heap",
    title: "Merge 2 Binary Max Heaps",
    link:
      "https://practice.geeksforgeeks.org/problems/merge-two-binary-max-heap/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 338,
    topic: "Heap",
    title: "Kth largest sum continuous subarrays",
    link: "https://www.geeksforgeeks.org/k-th-largest-sum-contiguous-subarray/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 339,
    topic: "Heap",
    title: "Leetcode- reorganize strings",
    link: "https://leetcode.com/problems/reorganize-string/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 340,
    topic: "Heap",
    title: "Merge “K” Sorted Linked Lists [V.IMP]",
    link:
      "https://practice.geeksforgeeks.org/problems/merge-k-sorted-linked-lists/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 341,
    topic: "Heap",
    title: "Smallest range in “K” Lists",
    link:
      "https://practice.geeksforgeeks.org/problems/find-smallest-range-containing-elements-from-k-lists/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 342,
    topic: "Heap",
    title: "Median in a stream of Integers",
    link:
      "https://practice.geeksforgeeks.org/problems/find-median-in-a-stream/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 343,
    topic: "Heap",
    title: "Check if a Binary Tree is Heap",
    link: "https://practice.geeksforgeeks.org/problems/is-binary-tree-heap/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 344,
    topic: "Heap",
    title: "Connect “n” ropes with minimum cost",
    link: "https://practice.geeksforgeeks.org/problems/minimum-cost-of-ropes/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 345,
    topic: "Heap",
    title: "Convert BST to Min Heap",
    link: "https://www.geeksforgeeks.org/convert-bst-min-heap/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 346,
    topic: "Heap",
    title: "Convert min heap to max heap",
    link: "https://www.geeksforgeeks.org/convert-min-heap-to-max-heap/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 347,
    topic: "Heap",
    title:
      "Rearrange characters in a string such that no two adjacent are same.",
    link: "https://practice.geeksforgeeks.org/problems/rearrange-characters/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 348,
    topic: "Heap",
    title: "Minimum sum of two numbers formed from digits of an array",
    link: "https://practice.geeksforgeeks.org/problems/minimum-sum4058/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 351,
    topic: "Graph",
    title: "Create a Graph, print it",
    link: "https://1drv.ms/t/s!AqTOHFO77CqEiRua06v1PATyiFg5",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 352,
    topic: "Graph",
    title: "Implement BFS algorithm",
    link:
      "https://practice.geeksforgeeks.org/problems/bfs-traversal-of-graph/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 353,
    topic: "Graph",
    title: "Implement DFS Algo",
    link:
      "https://www.geeksforgeeks.org/depth-first-search-or-dfs-for-a-graph/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 354,
    topic: "Graph",
    title: "Detect Cycle in Directed Graph using BFS/DFS Algo",
    link: "https://www.geeksforgeeks.org/detect-cycle-in-a-graph/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 355,
    topic: "Graph",
    title: "Detect Cycle in UnDirected Graph using BFS/DFS Algo",
    link:
      "https://practice.geeksforgeeks.org/problems/detect-cycle-in-an-undirected-graph/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 356,
    topic: "Graph",
    title: "Search in a Maze",
    link: "https://practice.geeksforgeeks.org/problems/rat-in-a-maze-problem/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 357,
    topic: "Graph",
    title: "Minimum Step by Knight",
    link: "https://practice.geeksforgeeks.org/problems/steps-by-knight/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 358,
    topic: "Graph",
    title: "flood fill algo",
    link: "https://leetcode.com/problems/flood-fill/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 359,
    topic: "Graph",
    title: "Clone a graph",
    link: "https://leetcode.com/problems/clone-graph/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 360,
    topic: "Graph",
    title: "Making wired Connections",
    link:
      "https://leetcode.com/problems/number-of-operations-to-make-network-connected/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 361,
    topic: "Graph",
    title: "word Ladder",
    link: "https://leetcode.com/problems/word-ladder/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 362,
    topic: "Graph",
    title: "Dijkstra algo",
    link:
      "https://www.geeksforgeeks.org/dijkstras-shortest-path-algorithm-greedy-algo-7/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 363,
    topic: "Graph",
    title: "Implement Topological Sort",
    link: "https://practice.geeksforgeeks.org/problems/topological-sort/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 364,
    topic: "Graph",
    title:
      "Minimum time taken by each job to be solved given by a Directed Acyclic Graph",
    link:
      "https://www.geeksforgeeks.org/minimum-time-taken-by-each-job-to-be-solved-given-by-a-directed-acyclic-graph/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 365,
    topic: "Graph",
    title:
      "Find whether it is possible to finish all tasks or not from given dependencies",
    link:
      "https://www.geeksforgeeks.org/find-whether-it-is-possible-to-finish-all-tasks-or-not-from-given-dependencies/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 366,
    topic: "Graph",
    title: "Find the no. of Isalnds",
    link:
      "https://practice.geeksforgeeks.org/problems/find-the-number-of-islands/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 367,
    topic: "Graph",
    title:
      "Given a sorted Dictionary of an Alien Language, find order of characters",
    link: "https://practice.geeksforgeeks.org/problems/alien-dictionary/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 368,
    topic: "Graph",
    title: "Implement Kruksal’sAlgorithm",
    link:
      "https://www.geeksforgeeks.org/kruskals-minimum-spanning-tree-algorithm-greedy-algo-2/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 369,
    topic: "Graph",
    title: "Implement Prim’s Algorithm",
    link:
      "https://www.geeksforgeeks.org/prims-minimum-spanning-tree-mst-greedy-algo-5/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 370,
    topic: "Graph",
    title: "Total no. of Spanning tree in a graph",
    link: "https://www.geeksforgeeks.org/total-number-spanning-trees-graph/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 371,
    topic: "Graph",
    title: "Implement Bellman Ford Algorithm",
    link: "https://practice.geeksforgeeks.org/problems/negative-weight-cycle/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 372,
    topic: "Graph",
    title: "Implement Floyd warshallAlgorithm",
    link:
      "https://practice.geeksforgeeks.org/problems/implementing-floyd-warshall/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 373,
    topic: "Graph",
    title: "Travelling Salesman Problem",
    link: "https://www.geeksforgeeks.org/travelling-salesman-problem-set-1/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 374,
    topic: "Graph",
    title: "Graph ColouringProblem",
    link:
      "https://www.geeksforgeeks.org/graph-coloring-applications/#:~:text=Graph%20coloring%20problem%20is%20to,are%20colored%20using%20same%20color.",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 375,
    topic: "Graph",
    title: "Snake and Ladders Problem",
    link: "https://leetcode.com/problems/snakes-and-ladders/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 376,
    topic: "Graph",
    title: "Find bridge in a graph",
    link: "https://www.geeksforgeeks.org/bridge-in-a-graph/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 377,
    topic: "Graph",
    title: "Count Strongly connected Components(Kosaraju Algo)",
    link:
      "https://practice.geeksforgeeks.org/problems/strongly-connected-components-kosarajus-algo/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 378,
    topic: "Graph",
    title: "Check whether a graph is Bipartite or Not",
    link: "https://www.geeksforgeeks.org/bipartite-graph/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 379,
    topic: "Graph",
    title: "Detect Negative cycle in a graph",
    link:
      "https://www.geeksforgeeks.org/detect-negative-cycle-graph-bellman-ford/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 380,
    topic: "Graph",
    title: "Longest path in a Directed Acyclic Graph",
    link:
      "https://www.geeksforgeeks.org/find-longest-path-directed-acyclic-graph/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 381,
    topic: "Graph",
    title: "Journey to the Moon",
    link: "https://www.hackerrank.com/challenges/journey-to-the-moon/problem",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 382,
    topic: "Graph",
    title: "Cheapest Flights Within K Stops",
    link:
      "https://leetcode.com/problems/cheapest-flights-within-k-stops/description/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 383,
    topic: "Graph",
    title: "Oliver and the Game",
    link:
      "https://www.hackerearth.com/practice/algorithms/graphs/topological-sort/practice-problems/algorithm/oliver-and-the-game-3/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 384,
    topic: "Graph",
    title: "Water Jug problem using BFS",
    link: "https://www.geeksforgeeks.org/water-jug-problem-using-bfs/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 385,
    topic: "Graph",
    title: "Water Jug problem using BFS",
    link: "https://www.geeksforgeeks.org/water-jug-problem-using-bfs/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 386,
    topic: "Graph",
    title: "Find if there is a path of more thank length from a source",
    link:
      "https://www.geeksforgeeks.org/find-if-there-is-a-path-of-more-than-k-length-from-a-source/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 387,
    topic: "Graph",
    title: "M-ColouringProblem",
    link: "https://practice.geeksforgeeks.org/problems/m-coloring-problem/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 388,
    topic: "Graph",
    title: "Minimum edges to reverse o make path from source to destination",
    link:
      "https://www.geeksforgeeks.org/minimum-edges-reverse-make-path-source-destination/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 389,
    topic: "Graph",
    title: "Paths to travel each nodes using each edge(Seven Bridges)",
    link:
      "https://www.geeksforgeeks.org/paths-travel-nodes-using-edgeseven-bridges-konigsberg/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 390,
    topic: "Graph",
    title: "Vertex Cover Problem",
    link:
      "https://www.geeksforgeeks.org/vertex-cover-problem-set-1-introduction-approximate-algorithm-2/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 391,
    topic: "Graph",
    title: "Chinese Postman or Route Inspection",
    link:
      "https://www.geeksforgeeks.org/chinese-postman-route-inspection-set-1-introduction/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 392,
    topic: "Graph",
    title: "Number of Triangles in a Directed and Undirected Graph",
    link:
      "https://www.geeksforgeeks.org/number-of-triangles-in-directed-and-undirected-graphs/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 393,
    topic: "Graph",
    title:
      "Minimise the cashflow among a given set of friends who have borrowed money from each other",
    link:
      "https://www.geeksforgeeks.org/minimize-cash-flow-among-given-set-friends-borrowed-money/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 394,
    topic: "Graph",
    title: "Two Clique Problem",
    link:
      "https://www.geeksforgeeks.org/two-clique-problem-check-graph-can-divided-two-cliques/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 397,
    topic: "Trie",
    title: "Construct a trie from scratch",
    link: "https://www.geeksforgeeks.org/trie-insert-and-search/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 398,
    topic: "Trie",
    title: "Find shortest unique prefix for every word in a given list",
    link:
      "https://www.geeksforgeeks.org/find-all-shortest-unique-prefixes-to-represent-each-word-in-a-given-list/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 399,
    topic: "Trie",
    title: "Word Break Problem | (Trie solution)",
    link: "https://www.geeksforgeeks.org/word-break-problem-trie-solution/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 400,
    topic: "Trie",
    title: "Given a sequence of words, print all anagrams together",
    link: "https://practice.geeksforgeeks.org/problems/k-anagrams-1/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 401,
    topic: "Trie",
    title: "Implement a Phone Directory",
    link: "https://practice.geeksforgeeks.org/problems/phone-directory/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 402,
    topic: "Trie",
    title: "Print unique rows in a given boolean matrix",
    link:
      "https://practice.geeksforgeeks.org/problems/unique-rows-in-boolean-matrix/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 405,
    topic: "Dynamic Programming",
    title: "Coin ChangeProblem",
    link: "https://practice.geeksforgeeks.org/problems/coin-change2448/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 406,
    topic: "Dynamic Programming",
    title: "Knapsack Problem",
    link: "https://practice.geeksforgeeks.org/problems/0-1-knapsack-problem/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 407,
    topic: "Dynamic Programming",
    title: "Binomial CoefficientProblem",
    link: "https://practice.geeksforgeeks.org/problems/ncr1019/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 408,
    topic: "Dynamic Programming",
    title: "Permutation CoefficientProblem",
    link: "https://www.geeksforgeeks.org/permutation-coefficient/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 409,
    topic: "Dynamic Programming",
    title: "Program for nth Catalan Number",
    link: "https://www.geeksforgeeks.org/program-nth-catalan-number/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 410,
    topic: "Dynamic Programming",
    title: "Matrix Chain Multiplication ",
    link: "https://www.geeksforgeeks.org/matrix-chain-multiplication-dp-8/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 411,
    topic: "Dynamic Programming",
    title: "Edit Distance",
    link: "https://practice.geeksforgeeks.org/problems/edit-distance3702/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 412,
    topic: "Dynamic Programming",
    title: "Subset Sum Problem",
    link:
      "https://practice.geeksforgeeks.org/problems/subset-sum-problem2014/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 413,
    topic: "Dynamic Programming",
    title: "Friends Pairing Problem",
    link:
      "https://practice.geeksforgeeks.org/problems/friends-pairing-problem5425/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 414,
    topic: "Dynamic Programming",
    title: "Gold Mine Problem",
    link: "https://www.geeksforgeeks.org/gold-mine-problem/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 415,
    topic: "Dynamic Programming",
    title: "Assembly Line SchedulingProblem",
    link: "https://www.geeksforgeeks.org/assembly-line-scheduling-dp-34/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 416,
    topic: "Dynamic Programming",
    title: "Painting the Fenceproblem",
    link:
      "https://practice.geeksforgeeks.org/problems/painting-the-fence3727/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 417,
    topic: "Dynamic Programming",
    title: "Maximize The Cut Segments",
    link: "https://practice.geeksforgeeks.org/problems/cutted-segments/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 418,
    topic: "Dynamic Programming",
    title: "Longest Common Subsequence",
    link:
      "https://practice.geeksforgeeks.org/problems/longest-common-subsequence/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 419,
    topic: "Dynamic Programming",
    title: "Longest Repeated Subsequence",
    link:
      "https://practice.geeksforgeeks.org/problems/longest-repeating-subsequence/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 420,
    topic: "Dynamic Programming",
    title: "Longest Increasing Subsequence",
    link:
      "https://practice.geeksforgeeks.org/problems/longest-increasing-subsequence/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 421,
    topic: "Dynamic Programming",
    title: "Space Optimized Solution of LCS",
    link: "https://www.geeksforgeeks.org/space-optimized-solution-lcs/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 422,
    topic: "Dynamic Programming",
    title: "LCS (Longest Common Subsequence) of three strings",
    link: "https://practice.geeksforgeeks.org/problems/lcs-of-three-strings/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 423,
    topic: "Dynamic Programming",
    title: "Maximum Sum Increasing Subsequence",
    link:
      "https://practice.geeksforgeeks.org/problems/maximum-sum-increasing-subsequence4749/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 424,
    topic: "Dynamic Programming",
    title: "Count all subsequences having product less than K",
    link: "https://www.geeksforgeeks.org/count-subsequences-product-less-k/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 425,
    topic: "Dynamic Programming",
    title: "Longest subsequence such that difference between adjacent is one",
    link:
      "https://practice.geeksforgeeks.org/problems/longest-subsequence-such-that-difference-between-adjacents-is-one4724/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 426,
    topic: "Dynamic Programming",
    title: "Maximum subsequence sum such that no three are consecutive",
    link:
      "https://www.geeksforgeeks.org/maximum-subsequence-sum-such-that-no-three-are-consecutive/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 427,
    topic: "Dynamic Programming",
    title: "Egg Dropping Problem",
    link: "https://practice.geeksforgeeks.org/problems/egg-dropping-puzzle/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 428,
    topic: "Dynamic Programming",
    title: "Maximum Length Chain of Pairs",
    link: "https://practice.geeksforgeeks.org/problems/max-length-chain/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 429,
    topic: "Dynamic Programming",
    title: "Maximum size square sub-matrix with all 1s",
    link:
      "https://practice.geeksforgeeks.org/problems/largest-square-formed-in-a-matrix/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 430,
    topic: "Dynamic Programming",
    title: "Maximum sum of pairs with specific difference",
    link:
      "https://practice.geeksforgeeks.org/problems/pairs-with-specific-difference/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 431,
    topic: "Dynamic Programming",
    title: "Min Cost PathProblem",
    link: "https://practice.geeksforgeeks.org/problems/path-in-matrix3805/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 432,
    topic: "Dynamic Programming",
    title: "Maximum difference of zeros and ones in binary string",
    link:
      "https://practice.geeksforgeeks.org/problems/maximum-difference-of-zeros-and-ones-in-binary-string4111/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 433,
    topic: "Dynamic Programming",
    title: "Minimum number of jumps to reach end",
    link:
      "https://practice.geeksforgeeks.org/problems/minimum-number-of-jumps/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 434,
    topic: "Dynamic Programming",
    title: "Minimum cost to fill given weight in a bag",
    link:
      "https://practice.geeksforgeeks.org/problems/minimum-cost-to-fill-given-weight-in-a-bag1956/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 435,
    topic: "Dynamic Programming",
    title: "Minimum removals from array to make max –min <= K",
    link:
      "https://www.geeksforgeeks.org/minimum-removals-array-make-max-min-k/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 436,
    topic: "Dynamic Programming",
    title: "Longest Common Substring",
    link:
      "https://practice.geeksforgeeks.org/problems/longest-common-substring/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 437,
    topic: "Dynamic Programming",
    title: "Count number of ways to reacha given score in a game",
    link: "https://practice.geeksforgeeks.org/problems/reach-a-given-score/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 438,
    topic: "Dynamic Programming",
    title: "Count Balanced Binary Trees of Height h",
    link: "https://practice.geeksforgeeks.org/problems/bbt-counter/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 439,
    topic: "Dynamic Programming",
    title: "LargestSum Contiguous Subarray [V>V>V>V IMP ]",
    link: "https://practice.geeksforgeeks.org/problems/kadanes-algorithm/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 440,
    topic: "Dynamic Programming",
    title: "Smallest sum contiguous subarray",
    link: "https://www.geeksforgeeks.org/smallest-sum-contiguous-subarray/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 441,
    topic: "Dynamic Programming",
    title: "Unbounded Knapsack (Repetition of items allowed)",
    link:
      "https://practice.geeksforgeeks.org/problems/knapsack-with-duplicate-items4201/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 442,
    topic: "Dynamic Programming",
    title: "Word Break Problem",
    link: "https://practice.geeksforgeeks.org/problems/word-break/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 443,
    topic: "Dynamic Programming",
    title: "Largest Independent Set Problem",
    link:
      "https://www.geeksforgeeks.org/largest-independent-set-problem-dp-26/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 444,
    topic: "Dynamic Programming",
    title: "Partition problem",
    link:
      "https://practice.geeksforgeeks.org/problems/subset-sum-problem2014/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 445,
    topic: "Dynamic Programming",
    title: "Longest Palindromic Subsequence",
    link:
      "https://www.geeksforgeeks.org/longest-palindromic-subsequence-dp-12/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 446,
    topic: "Dynamic Programming",
    title: "Count All Palindromic Subsequence in a given String",
    link:
      "https://practice.geeksforgeeks.org/problems/count-palindromic-subsequences/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 447,
    topic: "Dynamic Programming",
    title: "Longest Palindromic Substring",
    link: "https://leetcode.com/problems/longest-palindromic-substring/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 448,
    topic: "Dynamic Programming",
    title: "Longest alternating subsequence",
    link:
      "https://practice.geeksforgeeks.org/problems/longest-alternating-subsequence/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 449,
    topic: "Dynamic Programming",
    title: "Weighted Job Scheduling",
    link: "https://www.geeksforgeeks.org/weighted-job-scheduling/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 450,
    topic: "Dynamic Programming",
    title: "Coin game winner where every player has three choices",
    link:
      "https://www.geeksforgeeks.org/coin-game-winner-every-player-three-choices/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 451,
    topic: "Dynamic Programming",
    title:
      "Count Derangements (Permutation such that no element appears in its original position) [ IMPORTANT ]",
    link: null,
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 452,
    topic: "Dynamic Programming",
    title: "Maximum profit by buying and selling a share at most twice [ IMP ]",
    link:
      "https://www.geeksforgeeks.org/maximum-profit-by-buying-and-selling-a-share-at-most-twice/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 453,
    topic: "Dynamic Programming",
    title: "Optimal Strategy for a Game",
    link:
      "https://practice.geeksforgeeks.org/problems/optimal-strategy-for-a-game/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 454,
    topic: "Dynamic Programming",
    title: "Optimal Binary Search Tree",
    link: "https://www.geeksforgeeks.org/optimal-binary-search-tree-dp-24/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 455,
    topic: "Dynamic Programming",
    title: "Palindrome PartitioningProblem",
    link:
      "https://practice.geeksforgeeks.org/problems/palindromic-patitioning4845/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 456,
    topic: "Dynamic Programming",
    title: "Word Wrap Problem",
    link: "https://practice.geeksforgeeks.org/problems/word-wrap/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 457,
    topic: "Dynamic Programming",
    title: "Mobile Numeric Keypad Problem [ IMP ]",
    link:
      "https://practice.geeksforgeeks.org/problems/mobile-numeric-keypad5456/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 458,
    topic: "Dynamic Programming",
    title: "Boolean Parenthesization Problem",
    link:
      "https://practice.geeksforgeeks.org/problems/boolean-parenthesization/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 459,
    topic: "Dynamic Programming",
    title: "Largest rectangular sub-matrix whose sum is 0",
    link:
      "https://www.geeksforgeeks.org/largest-rectangular-sub-matrix-whose-sum-0/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 460,
    topic: "Dynamic Programming",
    title:
      "Largest area rectangular sub-matrix with equal number of 1’s and 0’s [ IMP ]",
    link:
      "https://www.geeksforgeeks.org/largest-area-rectangular-sub-matrix-equal-number-1s-0s/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 461,
    topic: "Dynamic Programming",
    title: "Maximum sum rectangle in a 2D matrix",
    link: "https://practice.geeksforgeeks.org/problems/maximum-sum-rectangle/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 462,
    topic: "Dynamic Programming",
    title: "Maximum profit by buying and selling a share at most k times",
    link: "https://practice.geeksforgeeks.org/problems/maximum-profit4657/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 463,
    topic: "Dynamic Programming",
    title: "Find if a string is interleaved of two other strings",
    link: "https://practice.geeksforgeeks.org/problems/interleaved-strings/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 464,
    topic: "Dynamic Programming",
    title: "Maximum Length of Pair Chain",
    link: "https://leetcode.com/problems/maximum-length-of-pair-chain/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 467,
    topic: "Bit Manipulation",
    title: "Count set bits in an integer",
    link: "https://practice.geeksforgeeks.org/problems/set-bits0143/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 468,
    topic: "Bit Manipulation",
    title:
      "Find the two non-repeating elements in an array of repeating elements",
    link:
      "https://practice.geeksforgeeks.org/problems/finding-the-numbers0215/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 469,
    topic: "Bit Manipulation",
    title: "Count number of bits to be flipped to convert A to B",
    link: "https://practice.geeksforgeeks.org/problems/bit-difference/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 470,
    topic: "Bit Manipulation",
    title: "Count total set bits in all numbers from 1 to n",
    link: "https://practice.geeksforgeeks.org/problems/count-total-set-bits/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 471,
    topic: "Bit Manipulation",
    title: "Program to find whether a no is power of two",
    link: "https://practice.geeksforgeeks.org/problems/power-of-2/0",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 472,
    topic: "Bit Manipulation",
    title: "Find position of the only set bit",
    link:
      "https://practice.geeksforgeeks.org/problems/find-position-of-set-bit3706/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 473,
    topic: "Bit Manipulation",
    title: "Copy set bits in a range",
    link: "https://www.geeksforgeeks.org/copy-set-bits-in-a-range/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 474,
    topic: "Bit Manipulation",
    title:
      "Divide two integers without using multiplication, division and mod operator",
    link:
      "https://www.geeksforgeeks.org/divide-two-integers-without-using-multiplication-division-mod-operator/",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 475,
    topic: "Bit Manipulation",
    title: "Calculate square of a number without using *, / and pow()",
    link:
      "https://www.geeksforgeeks.org/calculate-square-of-a-number-without-using-and-pow/#:~:text=Given%20an%20integer%20n%2C%20calculate,*%2C%20%2F%20and%20pow().&text=A%20Simple%20Solution%20is%20to%20repeatedly%20add%20n%20to%20result.",
    difficult: null,
    solved: false,
    favourite: false,
  },
  {
    id: 476,
    topic: "Bit Manipulation",
    title: "Power Set",
    link: "https://practice.geeksforgeeks.org/problems/power-set4302/1",
    difficult: null,
    solved: false,
    favourite: false,
  },
];

export default data;
